<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="isVisible"
    custom-class="dialog-long-form"
    :class="{'is-edit-mode': isEditMode, 'is-new': state === 'new'}"
    :closeOnClickModal="false"
    append-to-body
    @close="handleDialogClose">
    <div v-loading="isLoading">
      <form-editor
        :disabled="disabled"
        :data="data"
        :model="formModel"
        :hasCreateNew="hasCreateNew"
        @updateModelItem="handlerUpdateModelItem"
        @change="handleFormData"
        ref="Form"/>
      <form-controls
        class="form-footer"
        :isBack="hasCreateNew"
        :isCancel="!hasCreateNew"
        :isCreate="!hasCreateNew && !disabled"
        :isSave="hasCreateNew && !disabled"
        :isDelete="hasCreateNew && !disabled"
        @command="setCommand">
        <div v-if="hasCreateNew" class="control btn-mobile-full" style="order: 1">
          <ui-button
            v-if="isAvailableToEditRFQs"
            class="btn-size-s btn-mobile-full"
            :disabled="data.chosen"
            @click="handlerQuickRFQ"
          >
            {{L10n('quick-rfq')}}
          </ui-button>
        </div>
      </form-controls>
    </div>
  </el-dialog>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
import { getDefaultRFQID } from '@/utils/shared'

export default {
  name: 'EditorSupplier',
  mixins: [FormWrapperAutoSave, FormWrapper],
  components: {
    'form-editor': () => import(/* webpackChunkName: 'Parts' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    config: { type: Object },
    editorID: { required: true },
    partID: { required: true }
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'RFQ2s/Patch/${data.id}'
    }
  },
  computed: {
    formTitle () {
      return this.formData.rfqid || this.checkEs6AndRun(this.title)
    },
    isAvailableToEditRFQs () {
      return this.permission(this.$store.getters.get('permissions'), 'isAllowToEditRFQs')
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        rfqid: getDefaultRFQID(),
        partID: this.partID,
        entryDate: new Date(),
        supplierCompanyID: null,
        employeeID: this.$store.getters.get('currentUser').employeeID,
        conditionID: null,
        qty: 1,
        price: '',
        currencyID: null,
        remarks: ''
      }
    },
    handleDialogClose () {
      let command = this.isAvailableToSave ? 'back' : 'cancel'
      this.setCommand(command)
    },
    handlerQuickRFQ () {
      this.$emit('on-quick-rfq', { row: { id: this.data.id } })
    }
  }
}
</script>
